import React from 'react';
import { IIcon } from './types';
import styled from 'styled-components';

interface ISGP extends IIcon {
  border?: boolean;
  'data-testid'?: string;
  background?: string;
  textColor?: string;
}

const SVG = ({
  className = 'icon',
  background = '#128152',
  textColor = 'white',
  'data-testid': dataTestId = 'qa-sgp-icon'
}: ISGP) => (
  <Wrapper backgroundColor={background}>
    <svg
      className={className}
      height="12"
      viewBox="0 0 22 12"
      fill={background}
      xmlns="http://www.w3.org/2000/svg"
      data-testid={dataTestId}>
      <path
        d="M4.22196 8.40341V9.9375C4.22083 9.95521 4.21335 9.97189 4.20091 9.98444C4.18848 9.99698 4.17195 10.0045 4.15441 10.0057H2.17853C2.12787 10.0057 2.11098 9.97159 2.11098 9.9375V8.33523H0V10.1932C0 11.267 0.709289 12 1.77322 12H4.54283C5.60676 12 6.33294 11.267 6.33294 10.1932V8.59091C6.33294 7.85795 6.06274 7.27841 5.58988 6.80114L2.17853 3.39205C2.12787 3.34091 2.11098 3.30682 2.11098 3.23864V2.0625C2.11098 2.01136 2.12787 1.99432 2.17853 1.99432H4.15441C4.18819 1.99432 4.22196 2.01136 4.22196 2.0625V3.64773H6.33294V1.78977C6.33294 0.732955 5.60676 0 4.54283 0H1.77322C0.709289 0 0 0.732955 0 1.78977V3.05114C0 3.78409 0.253318 4.36364 0.743065 4.84091L4.15441 8.25C4.18819 8.30114 4.22196 8.33523 4.22196 8.40341Z"
        fill={textColor}
      />
      <path
        d="M14.1666 10.1932V5.40341H10.8903V7.36364H12.0556V9.9375C12.0544 9.95521 12.047 9.97189 12.0345 9.98444C12.0221 9.99698 12.0056 10.0045 11.988 10.0057H10.0121C9.96148 10.0057 9.94459 9.97159 9.94459 9.9375V2.0625C9.94459 2.01136 9.96148 1.99432 10.0121 1.99432H11.988C12.0218 1.99432 12.0556 2.01136 12.0556 2.0625V3.64773H14.1666V1.78977C14.1666 0.732955 13.4404 0 12.3764 0H9.60684C8.55979 0 7.83361 0.732955 7.83361 1.78977V10.1932C7.83361 11.267 8.55979 12 9.60684 12H12.3764C13.4404 12 14.1666 11.267 14.1666 10.1932Z"
        fill={textColor}
      />
      <path
        d="M22 5.52267V1.8238C22 0.766984 21.2738 0.0340295 20.2099 0.0340295H15.6671V11.9658H17.778V7.31244H20.2099C21.2907 7.31244 22 6.57948 22 5.52267ZM19.889 2.06244V5.28403C19.889 5.33517 19.8552 5.35221 19.8215 5.35221H17.778V1.99426H19.8215C19.8552 1.99426 19.889 2.0113 19.889 2.06244Z"
        fill={textColor}
      />
    </svg>
  </Wrapper>
);

export default SVG;

const Wrapper = styled.span<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 0.4rem;
  width: 3.2rem;
  height: 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
